import styled from "styled-components";
export const BorderIconWrap = styled.div`
    height: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;